import PostForm from "./Container"

export default PostForm
